/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StatementModification
 */
export interface StatementModification {
    /**
     * 
     * @type {string}
     * @memberof StatementModification
     */
    controlId?: string;
    /**
     * 
     * @type {string}
     * @memberof StatementModification
     */
    partId?: string;
    /**
     * 
     * @type {string}
     * @memberof StatementModification
     */
    newStatement?: string;
    /**
     * 
     * @type {string}
     * @memberof StatementModification
     */
    modificationType?: string;
}

/**
 * Check if a given object implements the StatementModification interface.
 */
export function instanceOfStatementModification(value: object): value is StatementModification {
    return true;
}

export function StatementModificationFromJSON(json: any): StatementModification {
    return StatementModificationFromJSONTyped(json, false);
}

export function StatementModificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatementModification {
    if (json == null) {
        return json;
    }
    return {
        
        'controlId': json['controlId'] == null ? undefined : json['controlId'],
        'partId': json['partId'] == null ? undefined : json['partId'],
        'newStatement': json['newStatement'] == null ? undefined : json['newStatement'],
        'modificationType': json['modificationType'] == null ? undefined : json['modificationType'],
    };
}

export function StatementModificationToJSON(json: any): StatementModification {
    return StatementModificationToJSONTyped(json, false);
}

export function StatementModificationToJSONTyped(value?: StatementModification | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'controlId': value['controlId'],
        'partId': value['partId'],
        'newStatement': value['newStatement'],
        'modificationType': value['modificationType'],
    };
}

